import { Button } from '@/components/ui/button';

export const Navigation = ({ onCTAClick }) => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-border/50 backdrop-blur-lg bg-background/80">
      <div className="w-full max-w-[100vw] mx-auto px-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20 gap-2 sm:gap-4">
          {/* Logo */}
          <div className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0">
            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-gradient-to-br from-primary to-primary-glow flex items-center justify-center">
              <span className="text-base sm:text-lg font-bold text-primary-foreground">R</span>
            </div>
            <span className="text-base sm:text-lg lg:text-xl font-bold text-foreground font-['Space_Grotesk'] whitespace-nowrap">Ref Assist</span>
          </div>
          
          {/* CTA Button */}
          <Button 
            onClick={onCTAClick}
            className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium text-xs sm:text-sm lg:text-base px-3 sm:px-4 lg:px-6 h-9 sm:h-10 whitespace-nowrap flex-shrink-0"
          >
            Join Early Access
          </Button>
        </div>
      </div>
    </nav>
  );
};
